import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import ModalBox from '../../../shared/modal';

import classname from 'classname';
import { Link } from 'react-router';
import DOMPurifyCreate from 'dompurify';
const DOMPurify = DOMPurifyCreate(window);

lessRequire('modules/offers/components/popups/rules.less');

const Rules = (props) => {
	const className = classname({
		'ReactModal__Content': true,
		'ReactModal__Content--after-open': true,
		'modal-overlay__content': true,
		'rules-modal': true,
		'offers-rules-modal': true
	});
	return (
		<ModalBox
			body={ModalBody(props)}
			isOpen={props.offerInfo.shouldShowRules}
			onClose={props.toggleRules}
			title={`${props.intl('Добавить')} «${props.offerInfo.offerTitle}»`}
			className={className}
		/>
	);
};

Rules.propTypes = {
	shouldShowRules: PropTypes.bool,
	offerInfo: PropTypes.object,
	toggleRules: PropTypes.func,
	intl: PropTypes.func
};

const ModalBody = (props) => {
	return (
		<div className="rules-body">
			<div className="info clearfix">
				<p className='font-proxima-nova-regular'>
					<i>
						{props.intl('Добавив данный оффер Вы автоматически подтверждаете, что согласны с правилами')}
					</i>
				</p>
			</div>
			<div className="rule-wrap">
				{ process.env.CPA_ENV === 'everad' ?
					getRawRules(props.offerInfo.offerRules):
					getRules(props.offerInfo.offerRules)
				}
			</div>
			<div className="control-btn">
				{ addButtons(props) }
			</div>
		</div>
	);
};

ModalBody.propTypes = {
	intl: PropTypes.func,
	offerInfo: PropTypes.object
};

const addButtons = props => {
	let result;
	if (props.offerInfo && !props.offerInfo.offerAvailability && !props.offerInfo.offerAccessThreadId) {
		if (props.user.level === props.affiliateLevels.average && !props.offerInfo.offerAccessOnRequest) {
			result = (
				<button
					id={'join_offer'}
					className="button yellow-btn font-proxima-nova-semibold"
					onClick={e => props.addOffer(props.offerInfo.offerId)}>
					{props.intl('Подключить оффер')}
				</button>
			);
		} else {
			result = (
				<Link
					className="button yellow-btn font-proxima-nova-semibold"
					to={`tickets/request/offer-access/${props.offerInfo.offerId}/`}
				>
					{props.intl('Запросить доступ')}
				</Link>
			);
		}
		return (<div>
			{result}
			<button
				className="button cancel font-proxima-nova-semibold"
				onClick={e => props.toggleRules()}>
				{props.intl('Отмена')}
			</button>
		</div>);
	}
};

addButtons.propTypes = {
	toggleRules: PropTypes.func,
	offerInfo: PropTypes.object,
	user: PropTypes.object,
	affiliateLevels: PropTypes.object,
	addOffer: PropTypes.func,
	intl: PropTypes.func
};

// functions
const getRules = rules => {
	if (!rules) return '';
	const rawData = rules.split('\n\n');

	if (rawData.length > 3) {
		return (
			<div className="rule-wrap__item">
				<h3 className="font-proxima-nova-semibold">{rawData[0]}</h3>
				<ul>
					{ rawData.slice(1).map((text, i) => (
						<li key={i}><p>{text}</p></li>
					)) }
				</ul>
			</div>
		);
	}

	return <span className="rule">{rules}</span>;
};
// functions
const getRawRules = rules => {
	return <div className="rule-wrap__item" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(rules)}}></div>;
};
export default Rules;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/popups/rules.js